/**
 * Generated runtime TestId mirror for frontend/src/pages/FormLayoutListPage.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const FormLayoutListPageTestIds = {
  badgeStatusActive: "badge-status-active",
  badgeStatusDefault: "badge-status-default",
  badgeStatusInactive: "badge-status-inactive",
  colFormFields: "col-form-fields",
  colKey: "col-key",
  colStatus: "col-status",
  colUseCase: "col-use-case",
  formLayoutListPage: "form-layout-list-page"
} as const;
